import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "./Unsubscribe.css";
import SEO from "../../Components/SEO/SEO";

const API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:5001";

export default function Unsubscribe() {
  const { token } = useParams();
  const [state, setState] = useState("loading"); // loading | done | error
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (!token) return;
    fetch(`${API_URL}/unsubscribe/${encodeURIComponent(token)}`)
      .then(async (r) => {
        const data = await r.json().catch(() => null);
        if (!r.ok || !data?.ok) {
          setState("error");
          return;
        }
        setEmail(data.email || "");
        setState("done");
      })
      .catch(() => setState("error"));
  }, [token]);

  return (
    <>
      <SEO title="Unsubscribe | ASX" description="Manage your ASX email preferences." noindex />
      <main className="unsub-root">
        <div className="unsub-card">
          {state === "loading" && (
          <p className="unsub-sub">Unsubscribing…</p>
        )}

        {state === "done" && (
          <>
            <div className="unsub-icon unsub-icon-success" aria-hidden>
              <svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
            </div>
            <h1 className="unsub-title">You're unsubscribed</h1>
            <p className="unsub-sub">
              {email ? <><strong>{email}</strong> will no longer receive our newsletter.</> : "You will no longer receive our newsletter."}
            </p>
            <Link to="/" className="unsub-btn">Back to All Star Xperience</Link>
          </>
        )}

        {state === "error" && (
          <>
            <div className="unsub-icon unsub-icon-warn" aria-hidden>
              <svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><path d="M12 8v4M12 16h.01" /></svg>
            </div>
            <h1 className="unsub-title">Link is invalid or expired</h1>
            <p className="unsub-sub">This unsubscribe link doesn't match any active subscriber.</p>
            <Link to="/" className="unsub-btn">Back to All Star Xperience</Link>
          </>
        )}
        </div>
      </main>
    </>
  );
}
